import React from 'react';
import { TafBadge } from '@taf-ui/react';
import ProgressBarStep from '../interfaces/ProgressBarStep';
import { translate } from '../utils/utils';
import Labels from '../enums/Labels';

import './badge.css';
import Language from 'enums/Language';

interface BadgeProps {
  orderNumber: number;
  name: string;
  clickHandler(): void;
  step?: ProgressBarStep;
  language: Language;
}

type BadgeMode =
  | 'none'
  | 'current'
  | 'success'
  | 'error'
  | 'warning'
  | undefined;

interface BadgeState {
  isSmallScreen: boolean;
}

class Badge extends React.PureComponent<BadgeProps, BadgeState> {
  private isSmallScreen: boolean = window.innerWidth < 1600;

  constructor(props: BadgeProps) {
    super(props);
    this.state = {
      isSmallScreen: window.innerWidth < 1600,
    };
  }

  componentDidMount(): void {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount(): void {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = (): void => {
    const isSmall = window.innerWidth < 1600;
    if (isSmall !== this.state.isSmallScreen) {
      this.setState({ isSmallScreen: isSmall });
    }
  };

  clickHandler = (): void => {
    const { clickHandler } = this.props;

    clickHandler();
  };

  getBadgeModeByStep = (step: ProgressBarStep | undefined): BadgeMode => {
    let mode: BadgeMode = 'none';

    if (step?.active) {
      mode = 'current';
    } else if (!step?.active && !step?.done) {
      mode = 'none';
    } else if (step?.done && step?.valid) {
      mode = 'success';
    } else if (step?.done && !step?.valid) {
      mode = 'error';
    }

    return mode as BadgeMode;
  };

  getStateofBadge = (
    name: string,
    step: ProgressBarStep | undefined,
    language: Language,
  ): string => {
    const title = this.isSmallScreen ? name : '';

    if (step?.active) {
      return translate(Labels.CURRENTLY_AT, language) + ' ' + title;
    } else if (step?.done && step?.valid) {
      return '';
    } else if (step?.done && !step?.valid) {
      return translate(Labels.ATTENTION_REQUIRED_AT, language) + ' ' + title;
    } else {
      return '';
    }
  };

  render(): React.ReactElement {
    const { orderNumber, name, step, language } = this.props;

    const isDashedBadge = !step?.active && !step?.done;

    return (
      <div className="badge-container">
        <TafBadge
          role="presentation"
          onClick={this.clickHandler}
          circular={true}
          dashed={isDashedBadge}
          mode={this.getBadgeModeByStep(step)}
          id={`badge_step_${orderNumber}`}
          key={orderNumber}
          title={this.isSmallScreen ? name : ''}
          aria-label={this.getStateofBadge(name, step, language)}
        >
          {orderNumber}
        </TafBadge>

        <span className="badge-label">{name}</span>
      </div>
    );
  }
}

export default Badge;
